// import Vue from 'vue'
// import Router from 'vue-router'
const Router = require('vue-router') 
import Home from '@/pages/Home'
// import OnlineExam from '@/pages/OnlineExam'
// import TestGame from '@/pages/TestGame'
// import Group from '@/pages/Group'
// import GroupCode from '@/pages/GroupCode'
// import DataPage from '@/pages/Data'
// import Attention from '@/pages/Attention'
// 考研模考
// import Graduate from '@/pages/graduate/index'
// import GraduateExamPoster from '@/pages/graduate/examPoster'
// import GraduateGamePoster from '@/pages/graduate/gamePoster'
// import GraduateDatum from '@/pages/graduate/datum'
// import GraduateActivity from '@/pages/graduate/activity'
// 资料
// import DatumDetail from '@/pages/datum/index'
// 临床
// import Clinic from '@/pages/clinic/index'
// 22医考
// import Exam2022 from '@/pages/exam/exam2022.vue'
// import Exam2022Cloud from '@/pages/exam/exam2022Cloud.vue'

// app 模考页点击电子版
import Mock from '@/pages/datum/mock.vue'

// 新的活动都在这里
// import A1 from '@/pages/activity/A1'
// import A1Game from '@/pages/activity/A1Game'
// import A1Exam from '@/pages/activity/A1Exam'
// import A1Datum from '@/pages/activity/A1Datum'
// import A2 from '@/pages/activity/A2/index'
// import A2Exam from '@/pages/activity/A2/exam'
// import A3 from '@/pages/activity/A3/index'
// import A3Exam from '@/pages/activity/A3/exam' 
// import A3Datum from '@/pages/activity/A3/datum'
// import A4 from '@/pages/activity/A4/index'
// import A4Exam from '@/pages/activity/A4/exam' 
// import A4Datum from '@/pages/activity/A4/datum'
// import A5 from '@/pages/activity/A5/index'
// import A5Exam from '@/pages/activity/A5/exam' 
// import A5Datum from '@/pages/activity/A5/datum'
// import A6 from '@/pages/activity/A6/index'
// import A7 from '@/pages/activity/A7/index'
// import A7Exam from '@/pages/activity/A7/exam' 
// import A7Datum from '@/pages/activity/A7/datum'
// import A8 from '@/pages/activity/A8/index'
// import A8Exam from '@/pages/activity/A8/exam' 
// import A8Datum from '@/pages/activity/A8/datum'
// import A9 from '@/pages/activity/A9/index'
// import A9Exam from '@/pages/activity/A9/exam' 
// import A10 from '@/pages/activity/A10/index'
// import A10Exam from '@/pages/activity/A10/exam' 
// import A10Datum from '@/pages/activity/A10/datum'
// import A11 from '@/pages/activity/A11/index'
// import A11Exam from '@/pages/activity/A11/exam' 
// import A11Datum from '@/pages/activity/A11/datum'
// import A12 from '@/pages/activity/A12/index'
// import A12Exam from '@/pages/activity/A12/exam' 
// import A12Datum from '@/pages/activity/A12/datum'
// import A13 from '@/pages/activity/A13/index'
// import A13Exam from '@/pages/activity/A13/exam' 
// import A13Datum from '@/pages/activity/A13/datum'
// import A14 from '@/pages/activity/A14/index'
// import A14Exam from '@/pages/activity/A14/exam' 
// import A14Datum from '@/pages/activity/A14/datum'
// import A15 from '@/pages/activity/A15/index'
// import A15Exam from '@/pages/activity/A15/exam' 
// import A15Datum from '@/pages/activity/A15/datum'


// 直播
// import Live from '@/pages/live/Live'
// import LiveList from '@/pages/live/List'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },    
    {
      path: '/online-exam',
      name: 'OnlineExam',
      component: resolve => require(['../pages/OnlineExam'], resolve),
    },
    {
      path: '/test-game',
      name: 'TestGame',
      component: resolve => require(['../pages/TestGame'], resolve),
    },
    {
      path: '/group',
      name: 'Group',
      component: resolve => require(['../pages/Group'], resolve),
    }, 
    {
      path: '/group/code',
      name: 'GroupCode',
      component: resolve => require(['../pages/GroupCode'], resolve)
    },
    {
      path: '/data',
      name: 'DataPage',
      component: resolve => require(['../pages/Data'], resolve)
    },
    {
      path: '/attention',
      name: 'Attention',
      component: resolve => require(['../pages/Attention'], resolve)
    },

    {
      path: '/graduate',
      name: 'Graduate',
      component: resolve => require(['../pages/graduate/index'], resolve)
    },
    {
      path: '/graduate/exam',
      name: 'GraduateExamPoster',
      component: resolve => require(['../pages/graduate/examPoster'], resolve)
    },
    {
      path: '/graduate/game',
      name: 'GraduateGamePoster',
      component: resolve => require(['../pages/graduate/gamePoster'], resolve)
    },
    {
      path: '/graduate/datum',
      name: 'GraduateDatum',
      component: resolve => require(['../pages/graduate/datum'], resolve)
    },
    {
      path: '/graduate/activity',
      name: 'GraduateActivity',
      component: resolve => require(['../pages/graduate/activity'], resolve)
    },
    {
      path: '/graduate/activity1',
      name: 'GraduateActivity1',
      component: resolve => require(['../pages/graduate/activity'], resolve)
    },
    {
      path: '/datum/:id',
      name: 'DatumDetail',
      component: resolve => require(['../pages/datum/index'], resolve)
    },

    {
      path: '/clinic',
      name: 'Clinic',
      component: resolve => require(['../pages/clinic/index'], resolve)
    },

    {
      path: '/exam2022',
      name: 'Exam2022',
      component: resolve => require(['../pages/exam/exam2022.vue'], resolve)
    },
    {
      path: '/exam2022/:id',
      name: 'Exam2022Cloud',
      component: resolve => require(['../pages/exam/exam2022Cloud.vue'], resolve)
    },
    {
      path: '/activity/1',
      name: 'A1',
      component: resolve => require(['../pages/activity/A1.vue'], resolve)
    },
    {
      path: '/activity/1g',
      name: 'A1Game',
      component: resolve => require(['../pages/activity/A1Game.vue'], resolve)
    },
    {
      path: '/activity/1e',
      name: 'A1Exam',
      component: resolve => require(['../pages/activity/A1Exam.vue'], resolve)
    },
    {
      path: '/activity/1d',
      name: 'A1Datum',
      component: resolve => require(['../pages/activity/A1Datum.vue'], resolve)
    },
    {
      path: '/activity/2',
      name: 'A2',
      component: resolve => require(['../pages/activity/A2/index.vue'], resolve)
    },
    {
      path: '/activity/2e',
      name: 'A2Exam',
      component: resolve => require(['../pages/activity/A2/exam.vue'], resolve)
    },
    {
      path: '/activity/3',
      name: 'A3',
      component: resolve => require(['../pages/activity/A3/index.vue'], resolve)
    },
    {
      path: '/activity/3e',
      name: 'A3Exam',
      component: resolve => require(['../pages/activity/A3/exam.vue'], resolve)
    },
    {
      path: '/activity/3d',
      name: 'A3Datum',
      component: resolve => require(['../pages/activity/A3/datum.vue'], resolve)
    },    
    {
      path: '/activity/4',
      name: 'A4',
      component: resolve => require(['../pages/activity/A4/index.vue'], resolve)
    },
    {
      path: '/activity/4e',
      name: 'A4Exam',
      component: resolve => require(['../pages/activity/A4/exam.vue'], resolve)
    },
    {
      path: '/activity/4d',
      name: 'A4Datum',
      component: resolve => require(['../pages/activity/A4/datum.vue'], resolve)
    },
    {
      path: '/activity/5',
      name: 'A5',
      component: resolve => require(['../pages/activity/A5/index.vue'], resolve)
    },
    {
      path: '/activity/5e',
      name: 'A5Exam',
      component: resolve => require(['../pages/activity/A5/exam.vue'], resolve)
    },
    {
      path: '/activity/5d',
      name: 'A5Datum',
      component: resolve => require(['../pages/activity/A5/datum.vue'], resolve)
    },  
    {
      path: '/mock-test',
      name: 'Mock',
      component: Mock
    },
    {
      path: '/activity/6',
      name: 'A6',
      component: resolve => require(['../pages/activity/A6/index.vue'], resolve)
    },
    {
      path: '/activity/7',
      name: 'A7',
      component: resolve => require(['../pages/activity/A7/index.vue'], resolve)
    },
    {
      path: '/activity/7e',
      name: 'A7Exam',
      component: resolve => require(['../pages/activity/A7/exam.vue'], resolve)
    },
    {
      path: '/activity/7d',
      name: 'A7Datum',
      component: resolve => require(['../pages/activity/A7/datum.vue'], resolve)
    },  
    {
      path: '/activity/8',
      name: 'A8',
      component: resolve => require(['../pages/activity/A8/index.vue'], resolve)
    },
    {
      path: '/activity/8e',
      name: 'A8Exam',
      component: resolve => require(['../pages/activity/A8/exam.vue'], resolve)
    },
    {
      path: '/activity/8d',
      name: 'A8Datum',
      component: resolve => require(['../pages/activity/A8/datum.vue'], resolve)
    },  
    {
      path: '/activity/9',
      name: 'A9',
      component: resolve => require(['../pages/activity/A9/index.vue'], resolve)
    },
    {
      path: '/activity/9e',
      name: 'A9Exam',
      component: resolve => require(['../pages/activity/A9/exam.vue'], resolve)
    },
    {
      path: '/activity/10',
      name: 'A10',
      component: resolve => require(['../pages/activity/A10/index.vue'], resolve)
    },
    {
      path: '/activity/10e',
      name: 'A10Exam',
      component: resolve => require(['../pages/activity/A10/exam.vue'], resolve)
    },
    {
      path: '/activity/10d',
      name: 'A10Datum',
      component: resolve => require(['../pages/activity/A10/datum.vue'], resolve)
    },
    {
      path: '/activity/11',
      name: 'A11',
      component: resolve => require(['../pages/activity/A11/index.vue'], resolve)
    },
    {
      path: '/activity/11e',
      name: 'A11Exam',
      component: resolve => require(['../pages/activity/A11/exam.vue'], resolve)
    },
    {
      path: '/activity/11d',
      name: 'A11Datum',
      component: resolve => require(['../pages/activity/A11/datum.vue'], resolve)
    },
    {
      path: '/activity/12',
      name: 'A12',
      component: resolve => require(['../pages/activity/A12/exam.vue'], resolve)
    },
    {
      path: '/activity/12e',
      name: 'A12Exam',
      component: resolve => require(['../pages/activity/A12/exam.vue'], resolve)
    },
    {
      path: '/activity/12d',
      name: 'A12Datum',
      component: resolve => require(['../pages/activity/A12/datum.vue'], resolve)
    },
    {
      path: '/activity/13',
      name: 'A13',
      component: resolve => require(['../pages/activity/A13/index.vue'], resolve)
    },
    {
      path: '/activity/13e',
      name: 'A13Exam',
      component: resolve => require(['../pages/activity/A13/exam.vue'], resolve)
    },
    {
      path: '/activity/13d',
      name: 'A13Datum',
      component: resolve => require(['../pages/activity/A13/datum.vue'], resolve)
    },
    {
      path: '/activity/14',
      name: 'A14',
      component: resolve => require(['../pages/activity/A14/index.vue'], resolve)
    },
    {
      path: '/activity/14e',
      name: 'A14Exam',
      component: resolve => require(['../pages/activity/A14/exam.vue'], resolve)
    },
    {
      path: '/activity/14d',
      name: 'A14Datum',
      component: resolve => require(['../pages/activity/A14/datum.vue'], resolve)
    },
    {
      path: '/activity/15',
      name: 'A15',
      component: resolve => require(['../pages/activity/A15/index.vue'], resolve)
    },
    {
      path: '/activity/15e',
      name: 'A15Exam',
      component: resolve => require(['../pages/activity/A15/exam.vue'], resolve)
    },
    {
      path: '/activity/15d',
      name: 'A15Datum',
      component: resolve => require(['../pages/activity/A15/datum.vue'], resolve)
    },
    {
      path: '/activity/16',
      name: 'A16',
      component: resolve => require(['../pages/activity/A16/index.vue'], resolve)
    },
    {
      path: '/activity/17',
      name: 'A17',
      component: resolve => require(['../pages/activity/A17/index.vue'], resolve)
    },
    {
      path: '/activity/18',
      name: 'A18',
      component: resolve => require(['../pages/activity/A18/index.vue'], resolve)
    },
    {
      path: '/activity/19',
      name: 'A19',
      component: resolve => require(['../pages/activity/A19/index.vue'], resolve)
    },
    {
      path: '/activity/19e',
      name: 'A19Exam',
      component: resolve => require(['../pages/activity/A19/exam.vue'], resolve)
    },
    {
      path: '/activity/19d',
      name: 'A19Datum',
      component: resolve => require(['../pages/activity/A19/datum.vue'], resolve)
    },
    {
      path: '/activity/19n',
      name: 'A19N',
      component: resolve => require(['../pages/activity/A19/new.vue'], resolve)
    },
    {
      path: '/activity/20',
      name: 'A20',
      component: resolve => require(['../pages/activity/A20/index.vue'], resolve)
    },
    {
      path: '/activity/21',
      name: 'A21',
      component: resolve => require(['../pages/activity/A21/index.vue'], resolve)
    },
    {
      path: '/activity/22',
      name: 'A22',
      component: resolve => require(['../pages/activity/A22/index.vue'], resolve)
    },
    {
      path: '/activity/23',
      name: 'A23',
      component: resolve => require(['../pages/activity/A23/index.vue'], resolve)
    },
    {
      path: '/activity/24',
      name: 'A24',
      component: resolve => require(['../pages/activity/A24/index.vue'], resolve)
    },
    {
      path: '/activity/25',
      name: 'A25',
      component: resolve => require(['../pages/activity/A25/index.vue'], resolve)
    },
    {
      path: '/activity/26',
      name: 'A26',
      component: resolve => require(['../pages/activity/A26/index.vue'], resolve)
    },
    {
      path: '/activity/27',
      name: 'A27',
      component: resolve => require(['../pages/activity/A27/index.vue'], resolve)
    },
    {
      path: '/activity/27e',
      name: 'A27Exam',
      component: resolve => require(['../pages/activity/A27/exam.vue'], resolve)
    },
    {
      path: '/activity/27d',
      name: 'A27Datum',
      component: resolve => require(['../pages/activity/A27/datum.vue'], resolve)
    },
    {
      path: '/activity/28',
      name: 'A28',
      component: resolve => require(['../pages/activity/A28/index.vue'], resolve)
    },
    {
      path: '/activity/29',
      name: 'A29',
      component: resolve => require(['../pages/activity/A29/index.vue'], resolve)
    },
    {
      path: '/activity/30',
      name: 'A30',
      component: resolve => require(['../pages/activity/A30/index.vue'], resolve)
    },
    {
      path: '/activity/31',
      name: 'A31',
      component: resolve => require(['../pages/activity/A31/index.vue'], resolve)
    },
    {
      path: '/activity/32',
      name: 'A32',
      component: resolve => require(['../pages/activity/A32/index.vue'], resolve)
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['../pages/test/index.vue'], resolve)
    },
    {
      path: '/case/detail/:id',
      name: 'CaseDetail',
      component: resolve => require(['../pages/case/detail.vue'], resolve)
    },
    {
      path: '/recruit/form',
      name: 'RecruitForm',
      component: resolve => require(['../pages/recruit/form.vue'], resolve)
    },
    {
      path: '/recruit/detail/:id',
      name: 'RecruitDetail',
      component: resolve => require(['../pages/recruit/detail.vue'], resolve)
    },
    {
      path: '/recruit/preview/:id',
      name: 'RecruitPreview',
      component: resolve => require(['../pages/recruit/preview.vue'], resolve)
    },
    {
      path: '/recruit/area/:id',
      name: 'RecruitArea',
      component: resolve => require(['../pages/recruit/area.vue'], resolve)
    },
    {
      path: '/recruit/question/:id',
      name: 'RecruitQuestion',
      component: resolve => require(['../pages/recruit/question.vue'], resolve)
    },
    {
      path: '/recruit/success',
      name: 'RecruitSuccess',
      component: resolve => require(['../pages/recruit/success.vue'], resolve)
    },
    {
      path: '/recruit/contact',
      name: 'RecruitContact',
      component: resolve => require(['../pages/recruit/contact.vue'], resolve)
    },
    {
      path: '/recruit/content',
      name: 'RecruitContent',
      component: resolve => require(['../pages/recruit/content.vue'], resolve)
    },
    {
      path: '/pdf',
      name: 'Pdf',
      component: resolve => require(['../pages/pdf/index.vue'], resolve)
    },
    {
      path: '/download-coupon',
      name: 'DownloadCoupon',
      component: resolve => require(['../pages/datum/download-coupon.vue'], resolve)
    },
    // 直播
    // {
    //   path: '/live',
    //   name: 'Live',
    //   component: Live
    // },
    // {
    //   path: '/live/list/:id',
    //   name: 'LiveList',
    //   component: LiveList
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js